import { fetch } from "../lib/network";
import AppSettings from "../config";
import { GQL } from "../types/GQL";
import queryString from "query-string";
import decamelizeKeys from "decamelize-keys";

export const fetchSearchCrmRequests = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) =>
  fetch(`${AppSettings.SEARCH_API_URL}/crm`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());

export const fetchSearchCeCases = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) =>
  fetch(`${AppSettings.SEARCH_API_URL}/code`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());

export const fetchSearchPermits = (networkHeaders: any) => (key: any, searchParams: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/permits`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams)),
    headers: networkHeaders,
  }).then((res: any) => {
    if (res.status === 200) {
      return res.json();
    }
    if (res.error) throw new Error(res.error);
    throw new Error(`Query failed with status ${res.status}`);
  });
};

//For the renewals list of a campaign
export const fetchRenewalSearchPermits = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/permits`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res: any) => {
    if (res.status === 200) {
      return res.json();
    }
    if (res.error) throw new Error(res.error);
    throw new Error(`Query failed with status ${res.status}`);
  });
};

//For manually connecting a renewal permit
export const getRenewalPermits =
  (networkHeaders: any) =>
  (query: {
    searchString: string;
    size: number;
    permitsTypeId: string;
    startedAt: number | string | null | undefined;
  }) =>
    fetch(
      `${AppSettings.SEARCH_API_URL}/permits/renewal_permits?${queryString.stringify(decamelizeKeys(query || {}, "_"), {
        arrayFormat: "bracket",
      })}`,
      {
        method: "GET",
        headers: networkHeaders,
      },
    ).then((res: any) => {
      if (res.status === 200) {
        return res.json();
      }
      if (res.error) throw new Error(res.error);
      throw new Error(`Query failed with status ${res.status}`);
    });

export const fetchTransactionLogs = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  searchParams.transaction_aggregates = true;
  return fetch(`${AppSettings.SEARCH_API_URL}/transactions`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());
};

export const fetchInspections = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) => {
  return fetch(`${AppSettings.SEARCH_API_URL}/inspections`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());
};

export const fetchPayouts = (networkHeaders: any) => (key: any, searchParams: any, cursor: any) =>
  fetch(`${AppSettings.SEARCH_API_URL}/payouts`, {
    method: "POST",
    body: JSON.stringify(Object.assign({}, searchParams, cursor ? { searchAfter: cursor } : {})),
    headers: networkHeaders,
  }).then((res) => res.json());

export const postPersonSearch = (networkHeaders: any) => (gql: GQL) =>
  fetch(`${AppSettings.SEARCH_API_URL}/person`, {
    method: "POST",
    body: JSON.stringify({ gql }),
    headers: networkHeaders,
  }).then((res) => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Query failed with status ${res.status}`);
  });
